import Vue from "vue"
import {
  AclInstaller,
  AclCreate,
  AclRule
} from "vue-acl"
import router from "@/router"

Vue.use(AclInstaller)

let initialRole = "public"

let userInfo = JSON.parse(localStorage.getItem("userInfo"))
if (userInfo && userInfo.userRole) initialRole = userInfo.userRole

export default new AclCreate({
  initial: initialRole,
  notfound: "/not-authorized",
  router,
  acceptLocalRules: true,
  globalRules: {
    public: new AclRule("admin").or("acc").or("fm").or("public").generate(),
    acc: new AclRule("admin").or("acc").generate(),
    fm: new AclRule("admin").or("fm").generate(),
    admin: new AclRule("admin").generate(),
  }
})